module.exports = __webpack_public_path__ + "media/images/icons/arrow-18d7272deef047903c6756aa61435b89.svg";